@if (locationFilteredReleaseNotes(location).length) {
<button mat-icon-button
    (click)="openDialog()">
    <mat-icon
      matBadge="{{ unreadReleaseNoteCount > 0 ? unreadReleaseNoteCount : '' }}"
      svgIcon="release-note"
    ></mat-icon>
  </button>
}
